import Vue from "vue";
import VueRouter from "vue-router";

import configurations from "commons/configurations";
import { AUTH_NAMESPACE, USER } from "store/modules/auth.js";
import BasePreLogin from '~/views/pre-login/BasePreLogin.vue'
import BasePostLogin from "~/views/post-login/BasePostLogin.vue";

Vue.use(VueRouter);

const has = (item) => sessionStorage.getItem(item) === 'true' ? undefined : { path: '/login' };
const remove = (items) => items.forEach(item => sessionStorage.removeItem(item));

// Rota utilizada apenas se o sistema estiver em manutenção
const routesManutencao = [
  {
    path: "*",
    name: "manutencao",
    component: () => import("~/views/ManutencaoView.vue"),
    meta: { title: configurations.app.name },
  },
]
// Todas as Rotas do sistema, ao criar uma nova rota, verificar se necessita da metatag 'breadcrumb'
const routes = [
  {
    path: "*",
    name: "not-found",
    component: () => import("~/views/404View.vue"),
    meta: { title: configurations.app.name },
  },
  {
    path: '/',
    component: BasePreLogin,
    children: [
      {
        path: '/',
        name: 'landingpage',
        component: () => import(/* webpackChunkName: "landingpage" */ '~/views/pre-login/BaseLandingPage.vue'),
      },
      {
        path: "/esqueci-senha",
        name: "Esqueci a Senha",
        component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/EsqueciSenha.vue"),
        meta: {
          title: "Esqueci a Senha"
        },
      },
      {
        path: "/login",
        name: "Login",
        component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/Login.vue"),
        beforeEnter: (to, from, next) => {
          remove(['canAccessCadastroPedagogico', 'canAccessPrimeiroAcesso']);
          next();
        },
      },
      {
        path: "/esqueci-senha",
        name: "Esqueci a Senha",
        component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/EsqueciSenha.vue"),
      },
      {
        path: "/primeiro-acesso/:cpf/:token",
        name: "Primeiro Acesso",
        component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/PrimeiroAcesso.vue"),
        beforeEnter: (to, from, next) => next(has('canAccessPrimeiroAcesso')),
      },
      {
        path: "/cadastro-pedagogico",
        name: "Cadastro Pedagógico",
        component: () => import( /* webpackChunkName: "pre-login" */ "~/views/pre-login/cadastro-pedagogico/CadastroPedagogicoView.vue"),
        beforeEnter: (to, from, next) => next(has('canAccessCadastroPedagogico')),
      },
    ]
  },

  {
    path: "/app",
    component: BasePostLogin,
    meta: {
      requiresAuth: true,
      title: "Início",
    },
    children: [
      {
        path: "/",
        component: () => import(/* webpackChunkName: "post-login" */ "views/post-login/Welcome.vue"),
        meta: {
          title: "Início",
        },
      },
      {
        path: "profissional/manter-profissional",
        name: "Profissional",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-profissional/ManterProfissionalView.vue"),
        meta: {
          title: "Profissional",
          breadcrumb: "Profissional/Manter Profissional",
        },
      },
      {
        path: "perfil/manter-perfil",
        name: "Perfil de Acesso",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-perfis/ManterPerfisView.vue"),
        meta: {
          title: "Perfil de Acesso",
          breadcrumb: "Perfil/Perfil de Acesso",
        },
      },
      {
        path: "grupo/manter-grupo",
        name: "Grupo",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-grupos/ManterGruposView.vue"),
        meta: {
          title: "Grupo",
          breadcrumb: "Grupo/Grupo",
        },
      },
      {
        path: "funcao/manter-funcao",
        name: "Função",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-funcoes/ManterFuncoesView.vue"),
        meta: {
          title: "Função",
          breadcrumb: "Função/Manter Função",
        },
      },
      {
        path: "lotacao/manter-lotacao",
        name: "Lotação",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-lotacoes/ManterLotacoesView.vue"),
        meta: {
          title: "Lotação",
          breadcrumb: "Lotação/Manter Lotação",
        },
      },
      {
        path: "habilidade/manter-habilidade",
        name: "Habilidade",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-habilidade/ManterHabilidadesView.vue"),
        meta: {
          title: "Habilidade",
          breadcrumb: "Habilidade/Manter Habilidade",
        },
      },
      {
        path: "turma/manter-turma",
        name: "Turma",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-turma/ManterTurmaView.vue"),
        meta: {
          title: "Turma",
          breadcrumb: "turma/Manter turma",
        },
      },
      {
        path: "turno/manter-turno",
        name: "Turno",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-turnos/ManterTurnosView.vue"),
        meta: {
          title: "Turno",
          breadcrumb: "Turno/Manter Turno",
        },
      },
      {
        path: "perfil-turma/manter-perfil-turma/:funcionalidade(leitura|escrita)",
        name: "Perfil da Turma em :funcionalidade",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-perfil-turma/ManterPerfilTurmaView.vue"),
        meta: {
          title: "Perfil da Turma",
          breadcrumb: "Manter Perfil da Turma/:funcionalidade",
        },
      },
      {
        path: "serie/manter-serie",
        name: "Ano/Série",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-serie/ManterSeriesView.vue"),
        meta: {
          title: "Ano/Série",
          breadcrumb: "Série/Manter Série",
        },
      },
      {
        path: "ano-letivo/manter-ano-letivo",
        name: "Ano Letivo",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-ano-letivo/ManterAnoLetivoView.vue"),
        meta: {
          title: "Ano Letivo",
          breadcrumb: "Ano Letivo/Manter Ano Letivo",
        },
      },
      {
        path: "solicitacoes-acesso/manter-solicitacoes-acesso",
        name: "Solicitacões de Acesso",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-solicitacao-de-acesso/ManterSolicitacaoAcessoView.vue"),
        meta: {
          title: "Solicitações de Acesso",
          breadcrumb: "Solicitações de Acesso",
        },
      },
      {
        path: "/cadastro-pedagogico/profissional",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/cadastro-pedagogico/CadastroPedagogicoView.vue"),
      },
      {
        path: "praticas-linguagem/manter-praticas-linguagem",
        name: "Praticas de Linguagem",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-praticas-linguagem/ManterPraticasLinguagemView.vue"),
        meta: {
          title: "Práticas de Linguagem",
          breadcrumb: "Práticas de Linguagem/Manter Práticas de Linguagem",
        },
      },
      {
        path: "unidades-tematicas/manter-unidades-tematicas",
        name: "Unidades Temáticas",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-unidades-tematicas/ManterUnidadesTematicasView.vue"),
        meta: {
          title: "Unidades Temáticas",
          breadcrumb: "Unidades Temáticas/Manter Unidades Temáticas",
        },
      },

      {
        path: "faqs/manter-faq",
        name: "FAQ",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-faq/ManterFaqView.vue"),
        meta: {
          title: "FAQs",
          breadcrumb: "FAQs/Manter FAQs",
        },
      },
      {
        path: "calendario/gerenciar-calendario-eventos/:id",
        name: "Gerenciar Calendário – Eventos",
        component: () =>
          import(/* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-calendario/dialogs/GerenciarCalendario.vue"),
        meta: {
          title: "Gerenciar Calendário – Eventos",
          breadcrumb: "Gerenciar Calendário – Eventos",
        },
      },
      {
        path: "calendario/manter-calendario",
        name: "Calendário",
        component: () =>
          import(/* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-calendario/ManterCalendarioView.vue"),
        meta: {
          title: "Calendário",
          breadcrumb: "Calendário",
        },
      },
      {
        path: "evento-calendarios/manter-evento-calendario",
        name: "Evento do Calendário",
        component: () => import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/manter-evento-calendario/ManterEventoCalendarioView.vue"),
        meta: {
          title: "Evento do Calendário",
          breadcrumb: "Evento do Calendário/Manter Evento do Calendário",
        },
      },
      {
        path: "turmas/manter-acompanhamento-de-turmas-professor",
        name: "Acompanhamento de Turmas - Professor",
        component: () =>
          import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/acompanhamento-de-turmas/professor/ManterAcompanhamentoDeTurmasProfessor.vue"),
        meta: {
          title: "Acompanhamento de Turmas - Professor",
          breadcrumb: "Acompanhamento de Turmas - Professor",
        },
      },
      {
        path: "turmas/manter-acompanhamento-de-turmas-professor/:id",
        name: "Acompanhamento de Turma - Professor",
        component: () =>
          import(/* webpackChunkName: "administrador" */ "~/views/post-login/administrador/acompanhamento-de-turmas/professor/EditarAcompanhamentoDeTurmasProfessor.vue"),
        meta: {
          title: "Editar Acompanhamento de Turma",
          breadcrumb: "Editar Acompanhamento de Turma",
        },
      },
      {
        path: "turmas/acompanhamento-de-turmas",
        name: "Acompanhamento de Turmas",
        component: () =>
          import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/acompanhamento-de-turmas/administracao/ManterAcompanhamentoDeTurmas.vue"),
        meta: {
          title: "Acompanhamento de Turmas",
          breadcrumb: "Acompanhamento de Turmas",
        },
      },
      {
        path: "turmas/acompanhamento-de-turmas/:cargo",
        name: "Acompanhamento de Turmas - :cargo",
        component: () =>
          import( /* webpackChunkName: "administrador" */ "~/views/post-login/administrador/acompanhamento-de-turmas/administracao/ManterAcompanhamentoDeTurmas.vue"),
        meta: {
          title: "Acompanhamento de Turmas - :cargo",
          breadcrumb: "Acompanhamento de Turmas",
        },
      },
      {
        path: "turmas/acompanhamento-de-turmas/visualizar/:id",
        name: "Acompanhamento de Turma - Visualizar",
        component: () =>
          import(/* webpackChunkName: "administrador" */ "~/views/post-login/administrador/acompanhamento-de-turmas/administracao/VisualizarAcompanhamentoDeTurmas.vue"),
        meta: {
          title: "Acompanhamento de Turma",
          breadcrumb: "Acompanhamento de Turma/Visualizar",
          hidePageName: true,
        },
      },
      // Demais Rotas
      {
        path: 'configurar/pagina-inicial',
        name: 'Gerenciar Homepage',
        component: () => import(/* webpackChunkName: "configuracao" */ 'views/post-login/base-configurations/CustomizeLandingPage.vue'),
        meta: {
          title: 'Gerenciar Homepage'
        },
      },
      {
        path: 'configurar/perfis',
        name: 'configureprofiles',
        component: () => import(/* webpackChunkName: "configuracao" */ 'views/post-login/base-configurations/permissions/Profiles.vue'),
        meta: {
          title: 'Configurar Perfis'
        },
      },
      // Relatórios de Log
      {
        path: "relatorio-log/manter-perfil",
        name: "Relatório de Log de Perfil",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-perfil/RelatorioLogPerfil.vue"),
        meta: {
          title: "Relatório de Log de Perfil",
          breadcrumb: "Relatório de Log de Perfil",
        },
      },
      {
        path: "relatorio-log/manter-turma",
        name: "Relatório de Log de Turma",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-turma/RelatorioLogTurma.vue"),
        meta: {
          title: "Relatório de Log de Turma",
          breadcrumb: "Relatório de Log de Turma",
        },
      },
      {
        path: "relatorio-log/manter-grupo",
        name: "Relatório de Log de Grupo",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-grupo/RelatorioLogGrupo.vue"),
        meta: {
          title: "Relatório de Log de Grupo",
          breadcrumb: "Relatório de Log de Grupo",
        },
      },
      {
        path: "relatorio-log/faq",
        name: "Relatório de Log de FAQ",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-faq/RelatorioLogFaq.vue"),
        meta: {
          title: "Relatório de Log de FAQ",
          breadcrumb: "Relatório de Log de FAQ",
        },
      },
      {
        path: "relatorio-log/manter-funcao",
        name: "Relatório de Log de Função",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-funcao/RelatorioLogFuncao.vue"),
        meta: {
          title: "Relatório de Log de Função",
          breadcrumb: "Relatório de Log de Função",
        },
      },
      {
        path: "relatorio-log/manter-unidade-tematica",
        name: "Relatório de Log de Unidade Temática",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-unidade-tematica/RelatorioLogUnidadeTematica.vue"),
        meta: {
          title: "Relatório de Log de Unidade Temática",
          breadcrumb: "Relatório de Log de Unidade Temática",
        },
      },
      {
        path: "relatorio-log/manter-lotacao",
        name: "Relatório de Log de Lotação",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-lotacao/RelatorioLogLotacao.vue"),
        meta: {
          title: "Relatório de Log de Lotação",
          breadcrumb: "Relatório de Log de Lotação",
        },
      },
      {
        path: "relatorio-log/manter-ano-serie",
        name: "Relatório de Log de Ano/Série",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-ano-serie/RelatorioLogAnoSerie.vue"),
        meta: {
          title: "Relatório de Log de Ano/Série",
          breadcrumb: "Relatório de Log de Ano/Série",
        },
      },
      {
        path: "relatorio-log/manter-habilidade",
        name: "Relatório de Log de Habilidade",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-habilidade/RelatorioLogHabilidade.vue"),
        meta: {
          title: "Relatório de Log de Habilidade",
          breadcrumb: "Relatório de Log de Habilidade",
        },
      },
      {
        path: "relatorio-log/manter-turno",
        name: "Relatório de Log de Turno",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-turno/RelatorioLogTurno.vue"),
        meta: {
          title: "Relatório de Log de Turno",
          breadcrumb: "Relatório de Log de Turno",
        },
      },
      {
        path: "relatorio-log/manter-ano-letivo",
        name: "Relatório de Log de Ano Letivo",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-ano-letivo/RelatorioLogAnoLetivo.vue"),
        meta: {
          title: "Relatório de Log de Ano Letivo",
          breadcrumb: "Relatório de Log de Ano Letivo",
        },
      },
      {
        path: "relatorio-log/manter-pratica-linguagem",
        name: "Relatório de Log de Práticas de Linguagem",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-praticas-linguagem/RelatorioLogPraticasLinguagem.vue"),
        meta: {
          title: "Relatório de Log de Práticas de Linguagem",
          breadcrumb: "Relatório de Log de Práticas de Linguagem",
        },
      },
      {
        path: "relatorio-log/manter-perfil-turma-leitura",
        name: "Relatório de Log de Perfil da Turma Leitura",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-perfil-turma-leitura/RelatorioLogPerfilTurmaLeitura.vue"),
        meta: {
          title: "Relatório de Log de Perfil da Turma Leitura",
          breadcrumb: "Relatório de Log de Perfil da Turma Leitura",
        },
      },
      {
        path: "relatorio-log/manter-perfil-turma-escrita",
        name: "Relatório de Log de Perfil da Turma Escrita",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-perfil-turma-escrita/RelatorioLogPerfilTurmaEscrita.vue"),
        meta: {
          title: "Relatório de Log de Perfil da Turma Escrita",
          breadcrumb: "Relatório de Log de Perfil da Turma Escrita",
        },
      },
      {
        path: "relatorio-log/manter-solicitacoes-acesso",
        name: "Relatório de Log de Solicitações de Acesso",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-solicitacoes-acesso/RelatorioLogSolicitacoesAcesso.vue"),
        meta: {
          title: "Relatório de Log de Solicitações de Acesso",
          breadcrumb: "Relatório de Log de Solicitações de Acesso",
        },
      },
      {
        path: "relatorio-log/manter-profissional",
        name: "Relatório de Log de Profissional",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-profissional/RelatorioLogProfissional.vue"),
        meta: {
          title: "Relatório de Log de Profissional",
          breadcrumb: "Relatório de Log de Profissional",
        },
      },
      {
        path: "relatorio-log/manter-evento-calendario",
        name: "Relatório de Log de Evento do Calendário",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-evento-calendario/RelatorioLogEventoCalendario.vue"),
        meta: {
          title: "Relatório de Log de Evento do Calendário",
          breadcrumb: "Relatório de Log de Evento do Calendário",
        },
      },
      {
        path: "relatorio-log/manter-acompanhamento-turmas",
        name: "Relatório de Log de Acompanhamento",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorio-de-logs/manter-acompanhamento-turma/RelatorioLogAcompanhamentoTurma.vue"),
        meta: {
          title: "Relatório de Log de Acompanhamento",
          breadcrumb: "Relatório de Log de Acompanhamento",
        },
      },
    ],
  }
];
const routerFactory = (store) => {
  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: configurations.env.manutencao == "true" ? routesManutencao : routes,
  });

  const updateThemeAndBackground = () => {
    router.app.$resetTheme();
  }

  const updateTitleAndMetadata = (to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

    if (nearestWithTitle) {
      document.title = nearestWithTitle.meta.title;
    } else if (previousNearestWithMeta) {
      document.title = previousNearestWithMeta.meta.title;
    }

    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).forEach((el) =>
      el.parentNode.removeChild(el)
    );

    if (!nearestWithMeta) return next();

    nearestWithMeta.meta.metaTags
      .map((tagDef) => {
        const tag = document.createElement("meta");
        Object.keys(tagDef).forEach((key) => {
          tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute("data-vue-router-controlled", "");
        return tag;
      })
      .forEach((tag) => document.head.appendChild(tag));
  }

  const authorize = (to, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      const user = store.getters[`${AUTH_NAMESPACE}/${USER}`];
      if (user) {
        next();
        return;
      }
      next({ path: "/login" });
    } else {
      next();
    }
  }

  router.beforeEach((to, from, next) => {
    updateTitleAndMetadata(to, from, next);
    authorize(to, next);
  });

  router.afterEach(() => {
    updateThemeAndBackground();
  });

  return router;
};

export default routerFactory;
